import { Col, Modal, Row, Image } from "react-bootstrap";
import "./ProjectModal.css";

export const ProjectModal = ({ showProject, hideProject, project }) => {

    return (
        <>
            <Modal
                show={showProject}
                onHide={hideProject}
                dialogClassName="modal-90w"
                aria-labelledby="project-modal"

            >
                <Modal.Header closeButton>
                    <Modal.Title id="project-modal" className="esd-font">
                        {project.name}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <Row>
                        <Col lg={6}>
                            <Image src={project.imgUrl} className="project-modal-img" />
                        </Col>
                        <Col lg={6}>
                            <p className="mt-2 mt-lg-0 text-center text-lg-start">
                                {project.description}
                            </p>
                            <div className="badges-container">
                                <p className="tech-used mb-0">Technologies used:</p>
                                {
                                    project.technologies !== undefined ?
                                        project.technologies.map((tech, index) => (
                                            <span className="badge bg-primary mx-1" key={index}>{tech}</span>
                                        )) : ""
                                }
                            </div>
                            {
                                project.sourceCodeUrl !== undefined ?
                                    <div className="project-modal-links d-flex justify-content-between mt-5">
                                        <a href={project.sourceCodeUrl} className="bg-grey" >source code <i className="bi bi-github"></i> </a>
                                        <a href={project.liveUrl} className="bg-success" >live demo <i className="bi bi-box-arrow-up-right"></i> </a>
                                    </div>
                                    : ""
                            }
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}